import { UNIT } from '../../../../constant'
import { WEIGHT_UNIT_KG_PER_LB } from '../../constants'

export function getLbsWeightUtil (weight, weightUnit) {
  if (!weightUnit || weightUnit === UNIT.IMPERIAL) {
    return weight
  }
  return weight / WEIGHT_UNIT_KG_PER_LB
}
